<script>
  export default {
    props: ['can', 'cant'],
    render() {
      if(this.display) {
        return this.$slots.default[0]
      }
    },
    computed: {
      currentUser() {
        return this.$store.state.me
      },
      display() {
        if(!this.currentUser) {
          return false
        }

        let can = this.currentUser.rights;
        if (!can) {
          if (this.currentUser.account_type === 'caregiver' && (this.can === 'read_documents' || this.can === 'play_games')) {
            return true
          } 
          return false
        }
        return (!this.can || can.indexOf(this.can) !== -1) &&
               (!this.cant || can.indexOf(this.cant) === -1)
      },
    }
  }
</script>
